import api from "./api"

export const getStockAlerts = async (locationType = "") => {
  const url = locationType
    ? `/stock-alerts?location_type=${locationType}`
    : "/stock-alerts"

  const response = await api.get(url)
  return response.data
}